import CompetitionSearchUsers from "./CompetitionSearchUsers";

function CompetitionAddUser( {users, row, setForm, saveUserToIndex}) {
 
 
  return (
  <div className="space-y-4 mt-2">
    <div className="grid gap-2">
    <div className="flex items-center gap-1">
        
        <span className="text-xs font-semibold text-gray-900 truncate">
            Nazwa indeksu:
        </span>
         <span className="text-xs font-medium text-gray-500">-</span>
        <span className="text-xs text-gray-900 truncate">
            {row.name}
        </span>
        
    </div>

     <CompetitionSearchUsers getfoundUsers={(selectedUser)=>saveUserToIndex(selectedUser.id)}/>
     </div>

          </div>
  );
}

export default CompetitionAddUser;